import * as d3 from 'd3'
import 'd3-scale'

const buildXScalePoint = (xAxis, width, padding) => {
  return d3.scalePoint().domain(xAxis).rangeRound([0, width]).padding(padding)
}

const buildXScaleBand = (xAxis, width, padding) => {
  return d3.scaleBand().domain(xAxis).rangeRound([0, width]).padding(padding)
}

const buildYScale = (yAxis, height) => {
  return d3.scaleLinear().domain(yAxis).range([height, 0])
}
export { buildXScalePoint, buildXScaleBand, buildYScale }
